module.exports = __webpack_public_path__ + "img/logo.df0960b1.png";